export class EntityOrderApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createOrder(body) {
    return this.#http.post('/entityOrder', body);
  }
}
